import {
  convertEnumFilterToApi,
  convertEnumFilterToArrayApi
} from 'v5/platform/filters/filterConverters';
import { Nullable } from 'v5/platform/typescript';

function browsingWorkspaceStamp(
  query: { workspaceId: Nullable<number> },
  convert: typeof convertEnumFilterToApi
): Record<string, unknown> {
  if (query.workspaceId === null) {
    return {};
  }

  return {
    enterprise_workspace_id: convert({
      operator: 'matchAny',
      value: [query.workspaceId]
    })
  };
}

/**
 * 1:N entity assignment (`enterprise_workspace_id` scalar).
 * matchAny → `$in`. Used by productions, shortlists, callouts.
 */
export function mergeWorkspaceScopingIntoHttpFilters(query: {
  workspaceId: Nullable<number>;
}): Record<string, unknown> {
  return browsingWorkspaceStamp(query, convertEnumFilterToApi);
}

/**
 * M:N membership indexed as an id array (contacts, and bookings via contact).
 * matchAny → bare `[workspaceId]` (`$eq` + `@>` / join-column IN).
 * Do not use scalar `$in` on this field.
 */
export function mergeWorkspaceMembershipScopingIntoHttpFilters(query: {
  workspaceId: Nullable<number>;
}): Record<string, unknown> {
  return browsingWorkspaceStamp(query, convertEnumFilterToArrayApi);
}
